import * as React from 'react';
import { Button, styled, TextareaAutosize, Typography } from '@mui/material';

import { MuiModal } from 'ui/MuiModal';
import { Column, Row } from 'ui/Flex';

const StyledMuiModal = styled(MuiModal)(({ theme }) => ({
    width: '100%',
    maxWidth: theme.spacing(160)
}));

const StyledColumn = styled(Column)(({ theme }) => ({
    gap: theme.spacing(2),
    maxHeight: 600,
    overflowY: 'auto'
}));

const StyledTextareaAutosize = styled(TextareaAutosize)(({ theme }) => ({
    width: 600,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    resize: 'vertical',
    overflowX: 'hidden' // Helps with some resize flickering
}));

const StyledTitle = styled(Typography)(({ theme }) => ({
    color: theme.palette.text.primary,
    fontWeight: 500
}));

type IProps = {
    title?: string;
    placeholder?: string;
    open: boolean;
    matchCodes: string;
    onClose: () => void;
    onConfirm: (matchCodes: string) => void;
};

export const ExpandedMatchCodesInputModal = ({
    open,
    onClose,
    matchCodes,
    onConfirm,
    title = 'Edit',
    placeholder = 'e.g. free drink'
}: IProps) => {
    const [inputValue, setInputValue] = React.useState(matchCodes);

    const handleChange = React.useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setInputValue(e.target.value);
    }, []);

    const handleConfirm = React.useCallback(() => {
        onConfirm(inputValue);
    }, [onConfirm, inputValue]);

    return (
        <StyledMuiModal open={open} onClose={onClose}>
            <StyledColumn>
                <StyledTitle variant="h6">{title}</StyledTitle>
                <StyledTextareaAutosize
                    value={inputValue}
                    onChange={handleChange}
                    aria-label="match-codes-input"
                    placeholder={placeholder}
                    minRows={4}
                    maxRows={10}
                />
                <Row flex={1} align="flex-end" gutter>
                    <Button variant="outlined" onClick={onClose}>
                        Cancel
                    </Button>
                    <Button variant="contained" onClick={handleConfirm}>
                        Confirm
                    </Button>
                </Row>
            </StyledColumn>
        </StyledMuiModal>
    );
};
